import { MarketCountryCode } from '@axo/shared/types';
import { InsuranceCardSection } from '../InsuranceCardSection';
import { MarketingPartnerConsentCardSection } from '../MarketingConsentCardSection/MarketingPartnerConsentCardSection';
import { PaymentRemarkSection } from '../PaymentRemarkSection';
import { PersonInfoSection } from '../PersonInfoSection';
import { KreditStatusConsent } from './KreditStatusConsent';
import { ApplicationConditionalWrapper } from '../ConditionalWrappers/ApplicationConditionalWrapper';

export type IApplicantDetails = {
  applicationID: string;
  personID: string;
  customerID: string;
};

export function ApplicantDetails({
  applicationID,
  personID,
  customerID,
}: IApplicantDetails) {
  return (
    <>
      <PersonInfoSection applicationID={applicationID} personID={personID} />
      {personID && customerID && (
        <>
          <MarketingPartnerConsentCardSection
            applicationID={applicationID}
            customerID={customerID}
          />
          <InsuranceCardSection
            applicationID={applicationID}
            customerID={customerID}
          />
          <ApplicationConditionalWrapper
            whitelist={[{ marketCountry: [MarketCountryCode.Denmark] }]}
          >
            <KreditStatusConsent applicationID={applicationID} />
          </ApplicationConditionalWrapper>
          <PaymentRemarkSection
            personID={personID}
            applicationID={applicationID}
          />
        </>
      )}
    </>
  );
}
